export default {pluginBlacklist:['local'],terminal:{recoverTabs:false},enableAnalytics:false,enableWelcomeTab:false,enableAutomaticUpdates:false};